export function Loader() {
  return (
    <div className="page-loader">
      <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
    </div>
  );
}
